export interface PartHealthLogItem {
  partNumber: string;
  date: Date;
  type: 'CPN' | 'MPN';
}
